import { get, post } from '@/request/http'

// 时间视图
export const gettimetask = (params) => get('/api/admin/gettimetask', params)

//时间视图-获取单个任务
export const gettaskbyid = (params) => get('/api/admin/gettaskbyid', params)

//时间视图-人员视图
export const gettimeuser = (params) => get('/api/admin/gettimeuser', params)


//全局视图
export const getviews = (params) => get('/api/admin/getviews', params)


//人员视图
export const getuserviews = (params) => get('/api/admin/getuserviews', params)


//人员视图详情
export const getusertask = (params) => get('/api/admin/getusertask', params)

//任务列表-甘特图
export const gettastview = (params) => get('/api/admin/gettastview', params)



// WEBPACK FOOTER //
// ./src/api/view.js